export const COLOR_ALL_TEST_STAT = '#A4FFA4'
export const COLOR_TEACHER_TEST_STAT = '#0000FFAA'
export const COLOR_TEACHER_TEST_WITHOUT_LAST_MONTH = '#0000FF77'
export const COLOR_TEACHER_TEST_WITHOUT_TWO_MONTH = '#0000FF55'
export const COLOR_TEACHER_TEST_WITHOUT_THREE_MONTH = '#0000FF33'

const STORE_KEY = 'INDIVIDUAL_PROFILE'

export const FETCH_STAT = `${STORE_KEY}/FETCH_STAT`

export const SET_STAT_DATA = `${STORE_KEY}/SET_STAT_DATA`

export const SET_IS_ALL_TEST_STAT = `${STORE_KEY}/SET_IS_ALL_TEST_STAT`
export const SET_IS_TEACHER_TEST_STAT = `${STORE_KEY}/SET_IS_TEACHER_TEST_STAT`
export const SET_IS_TEACHER_TEST_STAT_WITHOUT_LAST_MONTH = `${STORE_KEY}/SET_IS_TEACHER_TEST_STAT_WITHOUT_LAST_MONTH`
export const SET_IS_TEACHER_TEST_STAT_WITHOUT_TWO_MONTH = `${STORE_KEY}/SET_IS_TEACHER_TEST_STAT_WITHOUT_TWO_MONTH`
export const SET_IS_TEACHER_TEST_STAT_WITHOUT_THREE_MONTH = `${STORE_KEY}/SET_IS_TEACHER_TEST_STAT_WITHOUT_THREE_MONTH`
